import Tag from "@/components/Tags/Tag";
import useTranslations from "@/i18n/useTranslations";

const NewBadge = () => {
  const t = useTranslations("Common");

  return (
    <Tag
      title={t("newBadge")}
      color="orange"
      className="px-2 py-1 text-xs font-bold [border-radius:4px]"
    />
  );
};

export default NewBadge;
